module.exports = __webpack_public_path__ + "static/che15-ca762099552db38b9cb1025409b67f23.jpg";